import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '../../services/auth-service/auth.service';

export const AuthGuard: CanActivateFn = (route, state) => {

  const authService = inject(AuthService);
  const router = inject(Router);
  if (authService.isAuthenticated()) {
    return true;
  }
  authService.clearData();
  return router.createUrlTree(
    ['/'],
    { queryParams: { returnUrl: state.url } }
  );
};
